export default `
layout 
    name: breadthfirst
    directed: true

1 nodes -> 2 nodes

add 3 nodes

n5 <- n2 -> n6
connect n7 from n3 to n8

`